// helpers/privacyPolicy.js

/* =========================================================
   PRIVACY POLICY
========================================================= */

export const privacyPolicy = `
PRIVACY POLICY

Effective Date: January 1, 2026

1. INFORMATION WE COLLECT

We may collect:
• Name, username, and email address.
• Wallet addresses and transaction records.
• Device and usage information.
• Support communications.
• Security and fraud-prevention information.

2. HOW WE USE INFORMATION

Information may be used to:
• Create and maintain user accounts.
• Process transactions.
• Provide customer support.
• Improve security.
• Prevent fraud and abuse.
• Comply with legal obligations.

3. BLOCKCHAIN DATA

Transactions recorded on public blockchains are publicly visible and may be permanently recorded. Blockchain information cannot be modified or deleted by the platform.

4. SECURITY

Reasonable technical and organizational security measures are implemented to protect user information. However, no system can guarantee absolute security.

5. THIRD-PARTY SERVICES

The platform may use:
• Blockchain networks.
• Payment processors.
• Infrastructure providers.
• Cloud providers.
• Analytics and security services.

Third-party services operate under their own policies.

6. DATA RETENTION

Information may be retained for:
• Operational purposes.
• Security monitoring.
• Fraud prevention.
• Legal and regulatory compliance.
• Dispute resolution.

7. USER RESPONSIBILITY

Users are responsible for maintaining account security and protecting their login credentials.

8. CHANGES

This Privacy Policy may be updated periodically. Continued use of the platform constitutes acceptance of any updates.

9. CONTACT

Please contact support for privacy-related questions.
`;

/* =========================================================
   TERMS OF SERVICE
========================================================= */

export const termsOfService = `
TERMS OF SERVICE

By creating an account or using the platform, you agree to these terms.

1. ELIGIBILITY

You must:
• Be at least 18 years old.
• Have legal capacity to enter agreements.
• Be legally permitted to use digital asset services in your jurisdiction.

Users under 18 years of age are prohibited from using the platform.

Parents and legal guardians are responsible for taking reasonable steps to ensure that persons under their care do not use the platform.

2. ACCOUNT RESPONSIBILITY

You are responsible for:
• Maintaining account security.
• Protecting passwords and credentials.
• All activity occurring under your account.
• Maintaining accurate account information.

3. PROHIBITED ACTIVITIES

Users may not:
• Engage in fraud.
• Use stolen funds.
• Launder money.
• Circumvent platform rules.
• Exploit system vulnerabilities.
• Abuse the platform.
• Create, upload, share, distribute, or promote pornography or sexually explicit content.
• Promote, support, organize, finance, recruit for, or facilitate terrorism or terrorist organizations.
• Violate applicable laws.
4. DIGITAL ASSET TRANSACTIONS

Blockchain transactions may be irreversible once confirmed.

Users are responsible for verifying:
• Wallet addresses.
• Transaction details.
• Payment information.

5. ACCOUNT SUSPENSION

Accounts may be suspended, restricted, or terminated for violations of these terms or applicable laws.

6. SERVICE AVAILABILITY

Services may be modified, interrupted, or suspended without prior notice. Where reasonably practicable, users may be notified of significant service changes, interruptions, or suspensions.

7. LIMITATION OF LIABILITY

The platform shall not be liable for losses resulting from:
• User mistakes.
• Incorrect addresses.
• Blockchain failures.
• Network congestion.
• Third-party services.
• System outages.
• Security incidents.

8. GOVERNING LAW

These terms shall be governed by applicable laws and regulations.
9. INTELLECTUAL PROPERTY

The platform, including its software, source code, user interface, design, trademarks, logos, branding, graphics, documentation, text, and other platform content, is owned by or licensed to the platform and is protected by applicable intellectual property laws.

Use of the platform does not transfer ownership of any intellectual property rights to users.

Users may not, except as permitted by applicable law or with prior written permission:
• Modify, reverse engineer, or create derivative works from the platform.
• Remove or alter copyright, trademark, or proprietary notices.
• Use the platform's trademarks, logos, or branding in a manner that suggests endorsement or affiliation.

Users retain ownership of content they create or submit to the platform, but grant the platform a non-exclusive, worldwide, royalty-free license to host, store, process, and display that content solely as necessary to operate, secure, maintain, and provide the platform's services.

=========================================================
RISK DISCLOSURE
=========================================================

Stablecoins and digital asset transactions involve risks. Although stablecoins are designed to maintain a stable value, they may not always maintain that value under all circumstances.

10. STABILITY AND MARKET RISK

USDT and other stablecoins are designed to maintain a stable value. However, their market value may temporarily trade above or below the intended value due to market conditions, liquidity, demand, or other factors.

11. BLOCKCHAIN RISK

Blockchain networks may experience congestion, delays, network failures, forks, or other technical events that may affect the processing or settlement of transactions.

12. CUSTODIAL AND COUNTERPARTY RISK

Assets held through custodial systems or third-party services may be subject to operational, technological, financial, or security risks. Third-party service providers may also become unavailable or fail to perform their obligations.

13. TECHNOLOGY RISK

Software bugs, infrastructure failures, cyberattacks, security vulnerabilities, or service outages may affect platform functionality or transactions.

14. REGULATORY RISK

Digital asset and stablecoin regulations may change at any time and may affect the availability, use, transfer, or treatment of digital assets and related services.

15. P2P TRANSACTION RISK

Peer-to-peer transactions, including sending or receiving funds with another user, involve risks associated with counterparties, payment methods, transaction details, and user conduct.

Users are responsible for verifying the identity and payment information of their counterparties, confirming transaction details, and following the platform's transaction procedures.

Users are responsible for ensuring that they are transacting with a counterparty they trust before sending funds or releasing assets.

The platform cannot guarantee the performance, honesty, or availability of another user in a peer-to-peer transaction. Users should not release assets or confirm a transaction until the required payment or transaction conditions have been properly verified.

16. TRANSACTION IRREVERSIBILITY

Blockchain transactions may be irreversible once confirmed. Users are responsible for verifying wallet addresses, transaction amounts, and other transaction details before submitting a transaction.

17. LOSS OF ACCESS

Loss of account credentials, compromised accounts, wallet access issues, or user errors may result in loss of access to digital assets or platform services.

18. LIQUIDITY AND REDEMPTION RISK

Stablecoins may experience reduced liquidity or limited availability under certain market conditions. The ability to exchange or redeem a stablecoin may depend on the platform, market conditions, blockchain network, or applicable service providers.

Users should understand the risks associated with stablecoins, peer-to-peer transactions, and other digital asset services before using the platform.

=========================================================

DISCLAIMER

The platform does not provide investment, financial, tax, accounting, or legal advice.

Digital assets involve significant risk, including the possible loss of funds.

Information provided through the platform is for informational purposes only.

Users are solely responsible for:
• Investment decisions.
• Transactions.
• Compliance with applicable laws.
• Verification of wallet addresses.
• Verification of payment details.
• Security of their accounts.

The platform makes no guarantees regarding:
• Asset values.
• Market performance.
• Transaction profitability.
• Service availability.
• Future returns.

Users under 18 years of age are not allowed to use the platform.

Use of the platform is entirely at your own risk.
`;